import { computed, Injectable, Signal, signal } from '@angular/core';
import { ZerezHint } from './zerez-hint';

export interface ZerezSummaryEntry {
  /** Bezeichnung des Feldes in der Sammelkarte, z. B. „Wechselrichter 2“. */
  label: string;
  hint: ZerezHint;
}

/**
 * Sammelt die ZEREZ-Hinweise aller ZEREZ-ID-Felder eines Formulars für die Sammelkarte oben im
 * Formular. Wird im Formular selbst bereitgestellt (`providers: [ZerezHintRegistry]`), damit jedes
 * Formular nur seine eigenen Felder sammelt; jede `app-zerez-lookup` darunter meldet sich an und
 * beim Zerstören wieder ab.
 */
@Injectable()
export class ZerezHintRegistry {
  private readonly sources = signal<Signal<ZerezSummaryEntry | null>[]>([]);

  /** Aktuelle Einträge in Anmeldereihenfolge; Felder ohne Hinweis fehlen. */
  readonly entries = computed(() =>
    this.sources()
      .map((source) => source())
      .filter((entry): entry is ZerezSummaryEntry => !!entry)
  );

  add(source: Signal<ZerezSummaryEntry | null>): void {
    this.sources.update((sources) => [...sources, source]);
  }

  remove(source: Signal<ZerezSummaryEntry | null>): void {
    this.sources.update((sources) => sources.filter((s) => s !== source));
  }
}
